"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var reducer_1 = require("./reducer");
exports.ContextStateContext = react_1.default.createContext({
    values: {},
    dispatch: function (action) {
        /* this function gets overwritten when context is setup */
    } // tslint:disable-line
});
exports.ContextStateConsumer = function (props) {
    var values = props.values, children = props.children, onContextStateChange = props.onContextStateChange;
    var _a = react_1.default.useReducer(reducer_1.reducer, values || {}), state = _a[0], dispatch = _a[1];
    react_1.default.useEffect(function () {
        if (onContextStateChange) {
            onContextStateChange(state);
        }
    }, [state, onContextStateChange]);
    return (react_1.default.createElement(exports.ContextStateContext.Provider, { value: { values: state, dispatch: dispatch } },
        react_1.default.createElement(exports.ContextStateContext.Consumer, null, children)));
};
//# sourceMappingURL=ContextState.js.map